import type { CSSProperties } from 'react';

/** Branded globe loader for Clicks Tourism 360. */
export default function NetworkLoader({ size = 88 }: { size?: number }) {
  const pulse: CSSProperties = {
    animation: 'gisGlobePulse 1.4s ease-in-out infinite',
    transformBox: 'fill-box' as const,
    transformOrigin: 'center',
  };

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <style>{`
        @keyframes gisGlobePulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.06); opacity: 0.82; }
        }
        @media (prefers-reduced-motion: reduce) {
          @keyframes gisGlobePulse {
            0%, 100% { transform: scale(1); opacity: 1; }
          }
        }
      `}</style>

      <g style={pulse}>
        <circle cx="50" cy="50" r="40" fill="var(--color-accent-soft)" />
        <circle cx="50" cy="50" r="40" stroke="var(--color-brand-deep)" strokeWidth="3.5" />
        <ellipse cx="50" cy="50" rx="40" ry="14" stroke="var(--color-brand-line)" strokeWidth="2.5" />
        <ellipse cx="50" cy="50" rx="14" ry="40" stroke="var(--color-brand-line)" strokeWidth="2.5" />
        <path
          d="M50 10 C68 22, 68 78, 50 90 C32 78, 32 22, 50 10Z"
          stroke="var(--color-brand-node)"
          strokeWidth="2.5"
        />
        <circle cx="62" cy="38" r="5" fill="var(--color-brand-spark)" />
        <path d="M62 43 L62 52" stroke="var(--color-brand-spark)" strokeWidth="2.5" strokeLinecap="round" />
      </g>
    </svg>
  );
}
